// removed by extract-text-webpack-plugin
module.exports = {"docItem":"src-pages----podcast-module---docItem---7dxhM","excerpt":"src-pages----podcast-module---excerpt---2Qxnz","spotifyButton":"src-pages----podcast-module---spotifyButton---BI3w_","anchorButton":"src-pages----podcast-module---anchorButton---Wa0r9","docTitle":"src-pages----podcast-module---docTitle---1SjK2","episode":"src-pages----podcast-module---episode---1Un7I"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/podcast.module.css
// module id = 288
// module chunks = 172275779694091